// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"81":"Databases","322":"Reports","438":"Login","508":"NewPassword","547":"ResetPassword"}[chunkId] || chunkId) + "." + {"81":"777915be","322":"2e42ad96","437":"f241b935","438":"44d93e27","508":"77b03dac","547":"fa6ffdaa","856":"2edde80b"}[chunkId] + ".chunk.css";
};